export function setTextIfNew(node, newContent) {
    if (node.textContent != newContent)
        node.textContent = newContent;
}
export function removeChildren(node) {
    while (node.firstChild)
        node.removeChild(node.firstChild);
}
